<section class="w-full h-full bg-[#FAFAFA] md:ps-10 md:py-24 ps-4 py-8">
  <div class="flex flex-col items-center justify-center gap-4">
    <h2
      i18n="organizer.testimonial|Testimonial heading@@organizer.testimonial.title"
      class="text-2xl md:text-3xl font-bold text-black"
    >
      Testimonial
    </h2>
  </div>

  <!-- Scrollable cards -->
  <div
    #scrollContainer
    class="flex flex-row gap-4 mt-10 overflow-x-auto scroll-smooth pb-4 hide-scrollbar"
  >
    @for (testimonial of testimonials; track $index) {
      <div class="shrink-0 rounded-2xl overflow-hidden shadow-lg border border-gray-200">
        <iframe
          [src]="safeUrl(testimonial.videoUrl)"
          class="w-[300px] md:w-[420px] aspect-9/16"
          frameborder="0"
          allow="
            accelerometer;
            autoplay;
            clipboard-write;
            encrypted-media;
            gyroscope;
            picture-in-picture;
          "
          allowfullscreen
          [title]="testimonial.name"
        ></iframe>
        <!-- <div class="px-4 py-3 bg-white">
          <p class="text-sm font-medium text-gray-700">{{ testimonial.name }}</p>
          @if (testimonial.text) {
            <p class="text-xs text-gray-500 mt-1 line-clamp-2">{{ testimonial.text }}</p>
          }
        </div> -->
      </div>
    }
  </div>

  <!-- Navigation buttons -->
  <div class="flex justify-end gap-2 mt-2">
    <button
      (click)="scroll('left')"
      class="w-9 h-9 text-2xl flex items-center justify-center text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
      aria-label="Scroll left"
    >
      &#8249;
    </button>
    <button
      (click)="scroll('right')"
      class="w-9 h-9 text-2xl flex items-center justify-center text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer"
      aria-label="Scroll right"
    >
      &#8250;
    </button>
  </div>
</section>
